import { render } from "./lyAutoCodeStudentManage.vue?vue&type=template&id=504c7662"
import script from "./lyAutoCodeStudentManage.vue?vue&type=script&lang=js"
export * from "./lyAutoCodeStudentManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__